import { JsonItem } from "../../../shared/entities/pick-list/pick-list.entities";
import _ from "lodash";
import { DataViewer, DataViewType } from "./data-viewer";
import { PrintToPDF } from "../../scripts/print-functions";

export class ViewModal {
    modalId: string;
    displayName: string;
    viewTables: ViewModalTable[];
    filename: string;
    getPrintTitle: (obj: any) => string;

    currentItem: any;
    printToPdf: PrintToPDF;

    constructor(config: ViewModalConfig) {
        this.modalId = config.modalId;
        this.viewTables = config.viewTables;
        this.displayName = config.displayName;
        this.getPrintTitle = config.getPrintTitle;
        this.filename = config.filename;

        this.printToPdf = new PrintToPDF();
    }

    openModal(targetItem: any, pickLists: JsonItem[]) {
        this.currentItem = targetItem;
        this.initialize(pickLists);

        this.generateModalHtml(targetItem);
        this.initializePrintButton();

        $(`#${this.modalId}`).modal("show");

        // Initialize documents (if present)
        this.viewTables.forEach(table => {
            table.dataViewArray.forEach(view => {
                if (view.propertyType == DataViewType.DocumentUpload) {
                    view.getDocuments(targetItem);
                }
            })
        })
    }

    private initialize(pickLists: JsonItem[]): void {
        this.viewTables.forEach(table => table.initialize(pickLists));
    }

    private generateModalHtml(obj:any): void {
        let closeRow = `
            <div class="edit-item-modal-close-row">
                <div class="d-flex justify-content-end">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"><i class="fa-solid fa-xmark"></i></span>
                    </button>
                </div>
            </div>
        `;


        let headerRow = `
            <div class="edit-item-modal-header-row">
                <div class="d-flex" style="flex-direction: row-reverse;">
                    <div class="col edit-item-overview-block">
                        <div class="edit-item-title mt-2">
                            ${this.displayName}
                        </div>
                    </div>
                </div>
            </div>
        `;

        let viewTableBlock = ""; 
        this.viewTables.forEach(table => viewTableBlock += table.generateTableHtml(obj));

        let modalBody = `
            <div class="edit-item-modal-body">
                <div class="view-item-modal-container">
                    ${viewTableBlock}
                </div>
            </div>
        `;

        let printBtn = `
            <button type="button" class="butn view-item-print-btn mr-3">
                <span><i class="fa-solid fa-file-pdf pr-2"></i> Save PDF</span>
            </button>
        `

        let modalFooter = `
            <div class="edit-item-modal-footer">
                
                <button type="button" class="butn white" data-dismiss="modal" aria-label="Close">
                    <span>Close</span>
                </button>
            </div>
        `;


        let html = `
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    ${closeRow}
                    ${headerRow}
                    ${modalBody}
                    ${modalFooter}
                </div>

                <div class="modal-saving d-none">
                    <div class="saving-display d-none">
                        <div class="font-size20 font-weight-500 text-center pb-1">
                            Loading...
                        </div>
                        <div class="ciig-progress-loader d-flex justify-content-center">
                            <div class="loader"></div>
                        </div>
                    </div>
                    <div class="saved-display d-none">
                        <div class="font-size20 font-weight-500 text-center">
                            
                        </div>
                    </div>
                </div>
            </div>
        `;

        $(`#${this.modalId}`).empty().html(html);
    }

    private initializePrintButton() {
        let modal = $(`#${this.modalId}`);

        // Save Button
        let printBtn = modal.find(".view-item-print-btn");

        printBtn.on("click", () => {
            let viewTarget = modal.find(".view-item-modal-container");

            let title = this.getPrintTitle(this.currentItem);

            let prependHtml = `
                <div class="mb-4" style="color: black;">
                    <div class="d-flex align-items-start justify-content-between">
                        <div>
                            <div class="font-weight-600 font-size18">
                                ${title}
                            </div>
                        </div>
                    </div>
                </div>
            `;

            this.printToPdf.triggerPrint(viewTarget, this.filename, prependHtml);
        });
    }
}

export class ViewModalConfig {
    modalId: string;
    viewTables: ViewModalTable[];
    displayName: string;
    getPrintTitle: (obj: any) => string;
    filename: string;
}

export class ViewModalTable {
    tableTitle: string;
    dataViewArray: DataViewer[];
    customClass: string;

    constructor(tableTitle: string, dataViewArray: DataViewer[], customClass: string = "") {
        this.tableTitle = tableTitle;
        this.dataViewArray = dataViewArray;
        this.customClass = customClass;
    }

    initialize(pickLists: JsonItem[]) {
        this.dataViewArray.forEach(view => view.initialize(pickLists));
    }

    generateTableHtml(obj: any): string {
        let tableHeader = `
            <div class="d-flex view-table-header">
                <div class="col">
                    ${this.tableTitle}
                </div>
            </div>
        `;

        let tableRows = "";
        this.dataViewArray.forEach(view => {
            let displayVal = view.getDisplayValue(obj);
            let html = `
                <div class="d-flex view-table-row">
                    <div class="col-auto view-table-field-col">
                        ${view.displayName}
                    </div>
                    <div class="col view-table-value-col">
                        ${displayVal}
                    </div>
                </div>
            `;
            tableRows += html;
        });

        let html = `
            <div class="view-table-container">
                ${tableHeader}
                ${tableRows}
            </div>
        `;

        return html;
    }
}